import { ItemsActionNames } from '@/definitions/app/item.actions.name';
import { User } from '@/api';
import { actionHandler } from '@/store/data/ActionHandler';
import { MultisidebarItemTypes } from '@/store/multisidebar/types';
import { NButton } from '@/uikit';
import NDateTimeLabel from '@/uikit/datetime/NDateTimeLabel.vue';
import { ITableColumn } from '@/uikit/table/NTable.vue';
import NTableColumnCell from '@/uikit/table/NTableColumnCell.vue';
import NText from '@/uikit/text/NText.vue';
import AuditLogsImageIcon from '@/pages/audit-logs/table/AuditLogsImageIcon.vue';

export const auditLogsTableSchema: ITableColumn[] = [
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.user',
        name: 'user'
      }
    },
    content: {
      path: 'user_login',
      component: NButton,
      props: (item: any) => ({ label: item.user_login, type: 'link' }),
      on: {
        click(this: any) {
          navigateToUser(this.item.user_id);
        }
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.request_ip',
        name: 'request_ip'
      }
    },
    content: {
      path: 'request_ip',
      component: NText,
      props: {
        class: 'label-xs'
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.device_uid',
        name: 'device_uid'
      }
    },
    content: {
      path: 'device_uid',
      component: NText,
      props: {
        class: 'label-xs'
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.action_type',
        name: 'action_type'
      }
    },
    content: {
      component: NText,
      props: function (row: any) {
        return {
          class: 'label-xs',
          i18n_modelValue: `audit_logs.actionTypes.${row.action_type}`
        };
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.object_type',
        name: 'object_type'
      }
    },
    content: {
      component: NText,
      props: function (row: any) {
        return {
          class: 'label-xs',
          i18n_modelValue: `audit_logs.objectTypes.${row.object_type}`
        };
      }
    }
  },
  {
    header: {
      classes: ['align-right', 'bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.object_id',
        name: 'object_id'
      }
    },
    content: {
      path: 'object_id',
      classes: ['align-right'],
      component: NText,
      props: {
        class: 'label-xs'
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.created_date',
        name: 'created_date'
      }
    },
    content: {
      path: 'created_date',
      component: NDateTimeLabel,
      props: {
        class: 'label-xs'
      }
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'audit_logs.image',
        name: 'image'
      }
    },
    content: {
      path: 'fullframe',
      component: AuditLogsImageIcon,
      props: (item: any) => ({ bbox: item.bbox })
    }
  }
];

async function navigateToUser(id: User['id']): Promise<void> {
  await actionHandler.run(ItemsActionNames.ShowItem, { rawItem: id, type: MultisidebarItemTypes.Users });
}
